export const NAVIGATION_TIMEOUT = 1000; // eslint-disable-line import/prefer-default-export
